var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",on:{"click":function($event){return _vm.$emit('click')}}},[_c(_setup.FontAwesomeIcon,{staticClass:"icon",attrs:{"icon":['far', 'user-plus']}}),_c('span',[_vm._v("Create new user")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }